import {
  getServiceInfo,
  getServiceOrder,
  bindServiceCustomer
} from '@/api/slideBar'

const state = {
}

const mutations = {
}

const actions = {
  // F-用户服务-02-获取服务用户信息
  getServiceInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getServiceInfo(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // F-用户服务-01-获取服务订单
  getServiceOrder({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getServiceOrder(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // F-用户服务-03-绑定服务用户(群绑定)
  bindServiceCustomer({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      bindServiceCustomer(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
